import React from "react";
import { useTranslation } from "react-i18next";

export const CashOutHistoryTableHeader = () => {
	const { t } = useTranslation();

	return (
		<thead className="table--bet__header">
			<tr className="table--bet__header__row">
				<th className="table--bet__header__data u-type--left">
					{t("SYSTEM_COMBINATIONS.ORDINAL_NUMBER")}
				</th>
				<th className="table--bet__header__data u-type--left">
					{t("mybets:ITEM.INFO_DATE")}
				</th>
				<th className="table--bet__header__data u-type--right">
					{t("mybets:ITEM.CASHOUT_VALUE")}
				</th>
			</tr>
		</thead>
	);
};
